import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import MeApi from '../generated/api/Me';

export default (service: Servicelayer) => ({
  ...MeApi(service),

  // Add custom calls here

});
